'use client';

import { ComponentType, SVGProps } from 'react';

import { useTranslations } from 'next-intl';

import { H4, P } from '@/components/shared/Typography';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils/cn';

export type T_TokenInfoCardProps = {
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  count: number | string;
  isClaim: boolean;
  disabled?: boolean;
  className?: string;
  onClaim?: () => void;
};

function TokenInfoCard({
  Icon,
  title,
  count,
  isClaim,
  disabled,
  className,
  onClaim
}: T_TokenInfoCardProps) {
  const t = useTranslations();

  return (
    <div
      className={cn(
        className,
        'flex gap-2 flex-wrap items-center justify-between p-5 rounded-2xl w-full banner-gradient-animation'
      )}
    >
      <div>
        <P className="mb-1 text-sm font-me">{title}</P>
        <div className="flex gap-2 items-center">
          <Icon />
          <H4>{count}</H4>
        </div>
      </div>
      {isClaim && (
        <Button disabled={disabled} onClick={onClaim} variant="secondary">
          {t('profile.actions.claimAll')}
        </Button>
      )}
    </div>
  );
}

export default TokenInfoCard;
